import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ugcCommentShape, catalogBibShape } from '@bibliocommons/bc-prop-types';
import { selectCommunityCommentsForCurrentBib, selectUgcSummary } from 'app/selectors/bibs/UgcSelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectCurrentUserComments, selectCommentsTransactions } from 'app/selectors/ugc/CommentsSelector';
import BibsActions from 'app/actions/BibsActions';
import CommunityComments from './CommunityComments';

export class CommunityCommentsContainer extends React.PureComponent {
  render() {
    return <CommunityComments {...this.props} />;
  }
}

CommunityCommentsContainer.propTypes = {
  comments: ImmutablePropTypes.listOf(ugcCommentShape).isRequired,
  currentUserComments: ImmutablePropTypes.mapOf(ugcCommentShape),
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  summary: ImmutablePropTypes.map.isRequired,
  catalogBib: catalogBibShape.isRequired,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = state => {
  const catalogBib = selectCatalogBib(state);
  return {
    comments: selectCommunityCommentsForCurrentBib(state),
    currentUserComments: selectCurrentUserComments(state),
    commentsTransactions: selectCommentsTransactions(state),
    summary: selectUgcSummary(state),
    catalogBib
  };
};

const mapDispatchToProps = dispatch => ({
  bibsActions: bindActionCreators(BibsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CommunityCommentsContainer);
